import {Component } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sx-image-cropper',
  templateUrl: './imageCropper.component.html',
  styleUrls: ['./imageUploader.component.css'],
})
export class ImageCropperComponent {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;

  constructor(private modal: NgbModal, private activeModal: NgbActiveModal) {
  }

  fileChangeEvent(event: any): void {
      this.imageChangedEvent = event;
  }

  imageCropped(image: string) {
      this.croppedImage = image;
  }

  imageLoaded() {
    this.cropperReady = true;
  }

  loadImageFailed () {
    
  }

  confirmar() {
    this.activeModal.close(this.croppedImage);
  }

  dismiss() {
      this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/fileUpload/imageCropper.component.ts